(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('QuoteSplitDeleteController',QuoteSplitDeleteController);

    QuoteSplitDeleteController.$inject = ['$uibModalInstance', 'entity', 'QuoteSplit'];

    function QuoteSplitDeleteController($uibModalInstance, entity, QuoteSplit) {
        var vm = this;

        vm.quoteSplit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            QuoteSplit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
